// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBX4NIqDrL7SKaS8q0O1l89hifc3wZSvxo",
  authDomain: "newpollofeliz.firebaseapp.com",
  projectId: "newpollofeliz",
  storageBucket: "newpollofeliz.appspot.com",
  messagingSenderId: "214621067032",
  appId: "1:214621067032:web:31926e72305a619af6f06d",
  measurementId: "G-81WDYD6ZRK",
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Inicializa servicios específicos de Firebase
const auth = getAuth(app);

// Inicializa Firestore con configuración especial para solucionar el error "WebChannel transport errored"
const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
  // Si lo anterior no funciona, prueba esta opción:
  // experimentalForceLongPolling: true,
  merge: true,
});

const storage = getStorage(app);
const messaging = getMessaging(app);
const analytics = getAnalytics(app);

// Exporta los servicios para usarlos en otros archivos
export { auth, db, storage, messaging, analytics, app as default };
